import React, { Fragment, useState } from 'react';
import { createPortal } from 'react-dom';
import { getCategoryUrl, getSubcategoryUrl } from '../../utilities/urlHelper';

const DeleteCategoryWrapper = ({ category }) => {

    const [showModal, setShowModal] = useState(false);

    const openModal = () => setShowModal(true);

    const closeModal = () => setShowModal(false);

    return (
        <Fragment>
            <span className="dropdown-option red" onMouseDown={openModal}>Delete</span>
            {showModal && createPortal(<DeleteCategoryModal category={category} closeModal={closeModal} />, document.body)}
        </Fragment>
    );
};

const DeleteCategoryModal = ({ category, closeModal }) => {

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            closeModal();
        }
    };

    const isTopLevelCategory = !category.hasOwnProperty('category_id');

    const categoryText = isTopLevelCategory ? 'category' : 'subcategory';

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div data-details className="modal-content p2">
                <h3>
                    {`Delete ${categoryText} "${category.name}"`}
                </h3>
                <form action={isTopLevelCategory ? getCategoryUrl(category.id) : getSubcategoryUrl(category.id)} method="POST">
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input name="_method" type="hidden" value="delete" />
                    <input name="name" type="hidden" value={category.name} />
                    <div className="mb3" style={{ color: '#555459' }}>
                        <p>
                            {`Are you sure you want to permanently delete this ${categoryText}? This action cannot be undone.`}
                        </p>
                        <ul>
                            <li>
                                {`Pages, documents, and links in this ${categoryText} will be uncategorized and archived.`}
                            </li>
                            <li>Page requests will be uncategorized and closed.</li>
                            <li>Questions and answers will be uncategorized.</li>
                            <li>All contained subcategories will be deleted.</li>
                        </ul>
                        <p>
                            {`Please move any items you do not wish archived or deleted before deleting this ${categoryText}.`}
                        </p>
                    </div>
                    <div className="right-align">
                        <span className="btn-secondary mr1" onClick={closeModal}>Cancel</span>
                        <input type="submit" className="btn btn-primary bg-red" value={`Delete ${categoryText}`} />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeleteCategoryWrapper;
